import { render } from "./PersonaliaSettings.vue?vue&type=template&id=75241439"
import script from "./PersonaliaSettings.vue?vue&type=script&lang=js"
export * from "./PersonaliaSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__